import event from '../../../event'
import IEHackMixin from '../../helpers/IEHackMixin'
import FieldValue from '../../../mixins/FieldValue'

export default {
  props: [ 'component', 'isOpen', 'callerId', 'event', 'initData', 'title' ],
  mixins: [IEHackMixin, FieldValue],
  methods: {
    close () {
      event.$emit('right-close', {})
    },
    emitSearch () {
      if (!this.allBlank(this.entity)) {
        this.$nextTick(() => event.$emit(this.event, Object.assign({}, this.entity)))
      } else {
        event.$emit('toast', { message: 'Ensure you refine your search criteria', type: 'warning' })
      }
    },
    allBlank (obj) {
      for (let prop in obj) {
        if (!this.isBlank(obj[prop])) {
          return false
        }
      }
      return true
    },
    getSystemOptions (code) {
      return this.systemOptions.filter(({optionType}) => {
        return optionType !== null && optionType.hasOwnProperty('code') && optionType.code === code
      })
    }
  },
  computed: {
    systemOptions () {
      return this.$store.getters['systemOption/options']
    },
    countries () {
      return this.$store.getters['systemOption/countries']
    }
  },
  mounted () {
    this.$parent.$on('sidebarSubmitted', this.emitSearch)
  },
  beforeDestroy () {
    this.$parent.$off('sidebarSubmitted', this.emitSearch)
  }
}



// WEBPACK FOOTER //
// ./src/modules/admin/mixins/FilterMixin.js